import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';
import { movies } from '@/mocks/movies';

const accentClasses: Record<string, string> = {
  primary: 'bg-primary-100 text-primary-700',
  accent: 'bg-accent-100 text-accent-700',
  secondary: 'bg-secondary-100 text-secondary-700',
};

export default function CategoryQuickLinks() {
  return (
    <div className="grid grid-cols-2 gap-3 md:grid-cols-3 md:gap-4 lg:grid-cols-6">
      {categories.map((cat) => {
        const count = movies.filter((movie) => movie.categoryId === cat.id).length;
        return (
          <Link
            key={cat.id}
            to={`/category/${cat.id}`}
            className="group flex flex-col items-center gap-3 rounded-lg border border-background-200 bg-background-50 p-4 text-center transition-all duration-300 hover:-translate-y-1 hover:border-primary-200 md:p-5"
          >
            <span
              className={`flex h-12 w-12 items-center justify-center rounded-lg text-2xl ${
                accentClasses[cat.accent] ?? accentClasses.primary
              }`}
            >
              <i className={cat.icon} />
            </span>
            <div>
              <h3 className="font-heading text-sm font-bold text-foreground-950 transition-colors group-hover:text-primary-600 md:text-base">
                {cat.name}
              </h3>
              <p className="mt-0.5 font-label text-xs text-foreground-400">{count} 部内容</p>
            </div>
          </Link>
        );
      })}
    </div>
  );
}